import React from 'react';
import teethOperation from '../../../images/teeth-operation.png'
const ExceptionalDental = () => {
    return (
        <div className='container mt-5 pt-5'>
            <div className="row d-flex align-items-center">
                <div className="col-md-4">
                    <img className='img-fluid' src={teethOperation} alt="" />
                </div>
                <div className="col-md-8">
                    <h1 className='lh-6' style={{fontWeight:'600', color:'#203047'}}>Exceptional Dental <br/> Care, on Your Terms</h1>
                    <p className='text-muted fs-5 mt-5'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque quas ratione labore corporis doloribus quaerat. Odio consequatur quam neque quaerat? Voluptatum alias labore eveniet neque inventore qui soluta optio deleniti repudiandae ut saepe aliquam at excepturi sunt, esse facere maxime aspernatur cum molestias iusto? Porro illum velit a quo omnis numquam excepturi debitis maxime eos. Porro illo deleniti</p>

                    <button className='btn-similar mt-4' style={{padding: '12px 45px'}}>Learn More</button>
                </div>
            </div>
        </div>
    );
};

export default ExceptionalDental;